import React, { Component } from 'react'; 
import { Link } from 'react-router-dom';
import Social from '../section-components/social';
import Copyright from './copyright';

class Footer_v1 extends Component {
    componentDidMount() {
        const $ = window.$;
        let publicUrl = process.env.PUBLIC_URL + '/';
        const minscript = document.createElement("script");
        minscript.async = true;
        minscript.src = publicUrl + "assets/js/main.js";
        document.body.appendChild(minscript);

        $('.go-top').find('a').on('click', function () {
            $(".quarter-overlay").fadeIn(1);
            $(window).scrollTop(0);
            setTimeout(function () {
                $(".quarter-overlay").fadeOut(300);
            }, 800);
        });

        $(document).on('click', '.theme-btn-1', function () {
            $('div').removeClass('modal-backdrop show fade');
            $('body').attr("style", "");
        });
    }

    render() {
        return (
            <footer className="ltn__footer-area">
                <div className="footer-top-area section-bg-2 plr--5">
                    <div className="container-fluid">
                        <div className="row">
                            {/* Colonne Gauche */}
                            <div className="col-xl-4 col-md-6 col-sm-12">
                                <h4 className="footer-title">À PROPOS DE KEURGUI</h4>
                                <p>
                                    <strong>Keurgui.sn</strong> est une initiative de <strong>JD Immo</strong>,
                                    spécialisée dans le développement de solutions technologiques innovantes
                                    répondant aux exigences du secteur immobilier.
                                </p>
                            </div>

                            {/* Colonne Milieu */}
                            <div className="col-xl-4 col-md-6 col-sm-12">
                                <h4 className="footer-title">REJOIGNEZ-NOUS</h4>
                                <p>
                                    <strong>Participez à la révolution immobilière avec Keurgui !</strong>
                                    Professionnels de l’immobilier, profitez d’une visibilité accrue,
                                    d’outils performants et d’une communauté engagée pour booster
                                    votre activité en toute sécurité.
                                </p>
                            </div>

                            {/* Colonne Droite */}
                            <div className="col-xl-4 col-md-6 col-sm-12">
    <h4 className="footer-title">NOUS CONTACTER</h4>
    <p>
        Une question ou un commentaire ? 
        Remplissez notre formulaire de contact et échangez directement avec nous !
        <br />
        <a href="/contact" style={{ color: 'white', textDecoration: 'underline' }}>Contacter KEURGUI</a>

    </p>
</div>

                        </div>
                    </div>
                </div>
                <Copyright />
            </footer>
        );
    }
}

export default Footer_v1;